import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/compat/app'
import FIREBASE_CONFIG from './_firebase_config'

Vue.config.productionTip = false

firebase.initializeApp(FIREBASE_CONFIG)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
